<script setup lang="ts">

import type { appsLinkType } from '@/types/HeaderTypes';
import { Icon } from '@iconify/vue';
const appsLink: appsLinkType[] = [
    {
        avatar: 'chat-line-bold-duotone',
        color:'primary',
        title: 'Chat Application',
        subtext: 'New messages arrived',
        href: '/apps/chats'
    },
    {
        avatar: 'user-bold-duotone',
        color:'success',
        title: 'User Profile App',
        subtext: 'Get profile details',
        href: '/apps/user/profile'
    },
    {
        avatar: 'bill-list-bold-duotone',
        color:'secondary',
        title: 'eCommerce App',
        subtext: 'learn more information',
        href: '/ecommerce/products'
    },
   
    {
        avatar: 'calendar-minimalistic-bold-duotone',
        color:'primary',
        title: 'Calendar App',
        subtext: 'Get dates',
        href: '/apps/calendar'
    },
    {
        avatar: 'phone-calling-rounded-bold-duotone',
        color:'warning',
        title: 'Contact Application',
        subtext: '2 Unsaved Contacts',
        href: '/apps/contacts'
    },
    {
        avatar: 'settings-bold-duotone',
        color:'info',
        title: 'Account Setting App',
        subtext: 'Account settings',
        href: '/pages/account-settings'
    },
    {
        avatar: 'checklist-minimalistic-bold',
        color:'error',
        title: 'Kanban App',
        subtext: 'Get new Task',
        href: '/apps/kanban'
    },
    {
        avatar: 'notes-bold-duotone',
        color:'warning',
        title: 'Notes Application',
        subtext: 'To-do and Daily tasks',
        href: '/apps/notes'
    }
];
</script>
<template>
    <!-- ---------------------------------------------- -->
    <!-- apps link -->
    <!-- ---------------------------------------------- -->
    <v-row>
        <v-col cols="12" md="6" v-for="(item, i) in appsLink" :key="i">
            <router-link :to="item.href" class="text-decoration-none custom-text-primary">
                <div class="d-flex align-center">
                    <v-avatar size="45" :color=" 'light' + item.color" rounded="md">
                        <Icon :icon="'solar:' + item.avatar" height="24" :class="'text-' + item.color"/>
                    </v-avatar>
                    <div class="ml-3">
                        <h6 class="text-subtitle-1 mb-1 heading custom-title">{{ item.title }}</h6>
                        <p class="text-subtitle-2 textSecondary">{{ item.subtext }}</p>
                    </div>
                </div>
            </router-link>
        </v-col>
    </v-row>
</template>
